import { Default, Detail, List } from "./views";
import { ApplyAction } from "./wizards";

const Module = {
    name: "synchronizableleads",
    defaultRoutePath: "/synchronizableleads/leadfile",
    menuItemScope: "synchronizable",
    menuItemName: "leadFiles",
    routes: [{
        path: "/synchronizableleads/leadfile",
        protected: true,
        children: [
            {
                index: true,
                path: "",
                Component: Default,
            },
            {
                path: "list",
                Component: List,
            },
        ],
    },
    ],
    drawerRoutes: [
        {
            path: "applyAction",
            Component: ApplyAction,
        },
        {
            path: "detail",
            Component: Detail,
        },

        // {
        //     path: "create",
        //     Component: Create,
        // },
    ],

}

export default Module;
